
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Actions, ButtonLink, IconArrow } from 'braid-design-system';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "phase-3-ad-performance"
    }}>{`Phase 3: Ad Performance`}</h1>
    <p>{`The Ad Performance Panel can be embedded in web-based software for hirers to view the performance of their SEEK job ads in flow.`}</p>
    <p>{`This phase covers a new product launch and has no additional migration considerations.
Jump to the `}<a parentName="p" {...{
        "href": "/use-cases/ad-performance"
      }}>{`use case documentation`}</a>{` to get started:`}</p>

    <Actions mdxType="Actions">
  <ButtonLink href="/use-cases/ad-performance" icon={<IconArrow direction="right" mdxType="IconArrow" />} variant="soft" mdxType="ButtonLink">
    Ad Performance
  </ButtonLink>
    </Actions>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;